import React, { useEffect, useState } from "react";
import img1 from "./layers/img1.png";
import img3 from "./layers/img3.png";
import img4 from "./layers/img4.png";
import img6 from "./layers/img6.png";
import img7 from "./layers/img7.png";

export default function BagSVG(props) {
    const [handleColor, SetHandleColor] = useState(null);
    const [bagColor, SetBagColor] = useState(null);
    const [gussetColor, SetGussetColor] = useState(null);

    useEffect(() => {
        const rgb = hexToRgb(props.bagColor);
        SetBagColor(
            `${rgb.r / 255} 0 0 0 0  0 ${rgb.g / 255} 0 0 0  0 0 ${rgb.b / 255
            } 0 0  0 0 0 1 0`
        );
        // Helper function to convert HEX color to RGB
        function hexToRgb(hex) {
            if (hex.length === 4) {
                hex = "#" + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
            }
            const bigint = parseInt(hex.slice(1), 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;
            return { r, g, b };
        }
    }, [props.bagColor]);

    useEffect(() => {
        const rgb = hexToRgb(props.gussetColor);
        SetGussetColor(
            `${rgb.r / 255} 0 0 0 0  0 ${rgb.g / 255} 0 0 0  0 0 ${rgb.b / 255
            } 0 0  0 0 0 1 0`
        );
        // Helper function to convert HEX color to RGB
        function hexToRgb(hex) {
            if (hex.length === 4) {
                hex = "#" + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
            }
            const bigint = parseInt(hex.slice(1), 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;
            return { r, g, b };
        }
    }, [props.gussetColor]);

    useEffect(() => {
        const rgb = hexToRgb(props.handleColor);
        SetHandleColor(
            `${rgb.r / 255} 0 0 0 0  0 ${rgb.g / 255} 0 0 0  0 0 ${rgb.b / 255
            } 0 0  0 0 0 1 0`
        );
        // Helper function to convert HEX color to RGB
        function hexToRgb(hex) {
            if (hex.length === 4) {
                hex = "#" + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
            }
            const bigint = parseInt(hex.slice(1), 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;
            return { r, g, b };
        }
    }, [props.handleColor]);

    const divStyle = {
        opacity: 0.9,
    };

    return (
        <svg
            version="1.2"
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            className="svgProduct hover-magnify"
        >
            {/* Replace this with your actual SVG content */}
            <title>PP Customiser - BAGS</title>
            <defs>
                <image width="70%" id="bagimg1" href={img1} />
                {/* Logo---------------1 */}
                {/* Logo--------------2 */}
                <image width="8.3%" id="bagimg3" href={img3} />
                <image width="28%" id="bagimg4" href={img4} />
                <image width="9.3%" id="bagimg6" href={img6} />
                <image width="15.1%" id="bagimg7" href={img7} />
            </defs>

            <use
                id="BAGS_MAIN"
                style={{ filter: `url(#bagColor)` }}
                href="#bagimg1"
                x="15%"
                y="15%"
            />
            <image
                width={
                    props.logoSize === "medium"
                        ? "14%"
                        : props.logoSize === "small"
                            ? "10%"
                            : "19%"
                }
                className="bigBagLogo"
                xlinkHref={props.logo}
                x="47%"
                y="32%"
            />
            <use
                id="BAG_LRGE_GUSSET"
                style={{ filter: `url(#gussetColor)` }}
                href="#bagimg3"
                x="76.8%"
                y="18.1%"
            />
            <use
                id="BAG_LRGE _HANDLES"
                style={{ filter: `url(#handleColor)` }}
                href="#bagimg4"
                x="44.8%"
                y="16.8%"
            />
            <image
                width={
                    props.logoSize === "medium"
                        ? "9%"
                        : props.logoSize === "small"
                            ? "7%"
                            : "11%"
                }
                xlinkHref={props.logo}
                className="bagLogo"
                x="16%"
                y="52%"
            />
            <use
                id="BAG_SMALL_GUSSET"
                style={{ filter: `url(#gussetColor)` }}
                href="#bagimg6"
                x="32.8%"
                y="39.3%"
            />
            <use
                id="BAG_SMALL_HANDLES"
                style={{ filter: `url(#handleColor)` }}
                href="#bagimg7"
                x="17.2%"
                y="38.7%"
            />
            <filter id="bagColor">
                <feColorMatrix type="matrix" values={bagColor} />
            </filter>
            <filter id="handleColor">
                <feColorMatrix type="matrix" values={handleColor} />
            </filter>
            <filter id="gussetColor">
                <feColorMatrix type="matrix" values={gussetColor} />
            </filter>
        </svg>
    );
}
